
import EditorProductList from 'Editors/EditorProductList'
import EditorTipTap from 'Editors/EditorTipTap'
import Product from '@/components/ecommerce/shop/product/product'
export default {
  components: {
    Product,
    EditorTipTap,
    EditorProductList,
  },
}
